module.exports = __webpack_public_path__ + "static/media/logo.6ae2694b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/logo.svg
// module id = 793
// module chunks = 0